import type EmailAddressWrapper from 'owa-service/lib/contract/EmailAddressWrapper';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';

export function isSameStringIgnoreCase(str1: string, str2: string): boolean {
    // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
    // -> Error TS2322 (8,5): Type 'string | boolean' is not assignable to type 'boolean'.
    // @ts-expect-error
    return str1 === str2 || (str1 && str2 && str1.toLowerCase() == str2.toLowerCase());
}

export function isSelf(address: EmailAddressWrapper): boolean {
    return (
        address &&
        isSameStringIgnoreCase(
            // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
            // -> Error TS2345 (18,13): Argument of type 'string | undefined' is not assignable to parameter of type 'string'.
            // @ts-expect-error
            address.EmailAddress,
            // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
            // -> Error TS2532 (22,13): Object is possibly 'undefined'.
            // @ts-expect-error
            getUserConfiguration().SessionSettings.UserEmailAddress
        )
    );
}
